import { Injectable, signal } from '@angular/core';
import packageJson from '../../../package.json';

@Injectable({ providedIn: 'root' })
export class AppVersionService {
  readonly version = signal<string>('');
  readonly env = signal<string>('');
  readonly loaded = signal<boolean>(false);

  async load(): Promise<void> {
    const api: any = (window as any).electronAPI;
    if (api?.getAppConfig) {
      try {
        const cfg = await api.getAppConfig();
        this.version.set(cfg?.version || packageJson.version);
        this.env.set(cfg?.env || '');
      } catch {
        this.version.set(packageJson.version);
      }
    } else {
      this.version.set(packageJson.version);
      this.env.set('web');
    }
    this.loaded.set(true);
  }
}
